module.exports = __webpack_public_path__ + "static/media/S3P2_prostate-cancer-panels.17766715.mp3";